import React, {ReactElement} from "react";
import Redirect from "./Redirect";

export default function DefaultLanguageRedirect(): ReactElement {
    const {pathname} = window.location;
    const targetRoute = pathname === '/' ? '' : pathname;
    return <Redirect to={`${targetRoute}`}/>;
};
